module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1101.b2e1c5a0.png";